<div class="get-materials-panel"
     *ngIf="data">
  <div class="get-materials-panel__content">
    <form [formGroup]="getMaterialsGroup"
          class="get-materials-panel__form">
      <div class="get-materials-panel__form--left">
        <img src="{{ data.image.value.src }}"
             alt="{{ data.image.value.alt }}"
             [ngStyle]="{aspectRatio: data.image?.value?.width / data.image?.value?.height}">
      </div>
      <div class="get-materials-panel__form--right">
        <h2 class="get-materials-panel__title" #titleEl>{{ data.title.value }}</h2>
        <p class="get-materials-panel__form--right-textheader">{{ formText.name }}</p>
        <input class="get-materials-panel__form--right-text"
               formControlName="name"
               type="text"
               name="name" />
        <p class="get-materials-panel__form--right-textheader">{{ formText.email }}</p>
        <input class="get-materials-panel__form--right-text"
               formControlName="email"
               type="text"
               name="email" />
        <div class="get-materials-panel__form--right-check">
          <input type="checkbox"
                 formControlName="privacyPolicy"
                 id="policy-checkbox" />
          <label> {{ privacyPolicy.text }} <a *ngIf="data.cookiePolicyPageUrl"
              [routerLink]="data.cookiePolicyPageUrl"
              target="_blank"> {{ "getMaterialsPanel.PrivacyPolicy.Link" | translate }}
            </a> </label>
        </div>
        <div class="get-materials-panel__form--right--submit">
          <p class="get-materials-panel__form--right--submit--error"
             *ngIf="errMsg">{{ errMsg }}</p>
          <input (click)="sendRequest($event)"
                 class="get-materials-panel__form--right--submit--link bg-green-button"
                 type="submit"
                 value="{{ data.buttonText.value }}" />
        </div>
      </div>
    </form>
  </div>
  <div *ngIf="requestSuccess === true"
       class="get-materials-panel__modal">
    <div class="get-materials-panel__modal--content">
      <p>{{ succMsg }}</p>
    </div>
  </div>
</div>
